import { lazy, Suspense } from "react";
import { Navigate, useLocation } from "react-router-dom";

import LoadingScreen from "../../../shared/components/LoadingScreen";
import AuthGuard from "../../../shared/guards/AuthGuard";
import ShopLayout from "../../../shared/layouts/shopLayout";
import Escrow from "src/packages/escrow/view/Escrow";
import SplitBill from "src/packages/splitbill/views/SplitBill";
import MainSettings from "src/shared/layouts/MainSettings";
// import TransactionsApproval from "../components/TransactionsApproval";


const Loadable = (Component) => (props) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { pathname } = useLocation();

    return (
        <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
            <Component {...props} />
        </Suspense>
    );
};
const MOrder = Loadable(lazy(() => import('../view')));

export const MOrderRoutes = [
    // Dashboard Routes
    {
        path: 'shop-dashboard',
        element: (
            <AuthGuard>
                <ShopLayout />
            </AuthGuard>
        ),
        children: [
            { path: 'money-order-processings', element: <MOrder /> }
        ],
    },

];